import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

var routers = [{
  path: "/welcome",
  component: () => import('@/views/shell/welcome'),
}, {
  path: "/menu",
  component: () => import('@/views/shell/menu'),
}, {
  path: "/google",
  component: () => import('@/views/shell/google'),
}, {
  path: "/exprep",
  component: () => import('@/views/shell/exprep'),
}, {
  path: "/exBegin",
  component: () => import('@/views/shell/exBegin'),
}];

export default new Router({
  routes: routers
})
